import { createFileRoute } from "@tanstack/react-router";

import { IndustriesPage } from "../../../workspaces/work-atlas/pages/IndustriesPage";

export const Route = createFileRoute("/_console/p/$org/$project/work-atlas/")({
  component: IndustriesPage,
});
